import React, { Fragment } from "react";
import { Card, CardBody } from "reactstrap";

import Breadcrumbs from "Components/Breadcrumbs";
import EditItem from "Components/EditItemWithZod";
import ModalApp from "Components/ModalApp";
import AddItem from "Components/AddItemWithZod";

import { API, COLUMNS, EDIT_ITEMS, CREATE_ITEMS } from "./data";
import ForfaitsDataTable from "./ForfaitsDataTable";

import { EDIT_FORFAIT, MY_FORFAITS, CREATE_FORFAIT } from "Constant";
import { getProfileCode } from "helper/getDataFromCookies";
import CreateForfaitBtn from "./CreateForfaitBtn";

const ForfaitsPage = () => {
  const profileCode = getProfileCode();
  const list = API.list(profileCode);
  const columns = COLUMNS(profileCode);
  const breadCrumbsProps = [MY_FORFAITS];
  const canCreateFlatfee =
  (process.env.REACT_APP_ADD_FLATFEE || "").toLowerCase() === "true";


  return (
    <Fragment>
      <Card>
        <CardBody>
          <div className="p-4">
            <Breadcrumbs breadCrumbsProps={breadCrumbsProps} />
            
            <ForfaitsDataTable newColumns={columns} link={list} profileCode={profileCode} canCreateFlatfee={canCreateFlatfee} />
          </div>
        </CardBody>
      </Card>

      <ModalApp type="edit" title={EDIT_FORFAIT}>
        <EditItem itemsUpdate={EDIT_ITEMS} />
      </ModalApp>

{canCreateFlatfee && (
      <ModalApp type="createForfait" title={CREATE_FORFAIT} size="lg">
        <AddItem addURL={API.create(profileCode)} items={CREATE_ITEMS} />
      </ModalApp>
      )}
    </Fragment>
  );
};

export default ForfaitsPage;